.row {
  height: 4.8rem;
}

.cell {
  color: var(--white-default);
  font-size: 1.4rem;
  text-align: left;
  white-space: nowrap;
  border-bottom: 1px solid var(--color-grayscale-tuna);

  &:not(:last-child) {
    padding-right: 9.6rem;
  }

  &:first-child {
    padding-left: 1.6rem;
  }

  &:last-child {
    padding-right: 1.6rem;
  }
}

.name {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 1.2rem;
  color: var(--color-texts-medium-contrast);

  &[data-variant='warning'] {
    color: var(--color-warning);
  }
}
